export default "__VITE_ASSET__Cg_GotJi__";